
import { getTitleList } from '../../axios/invoice' 

const _storageData = {
  addressData: {
    addr_id:'',
    phone_no:'',
    receiver:'',
    address:'',
    province:'',
    city:'',
    county:'',
  },
  // 发票数据
  invoiceData:{
    title:'',
    invoice_type: 1,
    title_type: 1,
    user_type: sessionStorage.getItem('user_type'),
    tax_payer_identify_no:'',
    email:'',
    traveler_identity: '',
    traveler_name: '',
  },
  //更多数据
  moreInfoData:{
    remark:'',
    bank_account_no:'',
    ep_reg_contact:'',
    ep_reg_addr:'',
    bank_name:'',
    license_no:''
  }
}

//state
const state = {
   //是否有承运单
   hasTyOrder:'',
   //  地址数据
    addressData: _storageData.addressData,
    // 发票数据
    invoiceData: _storageData.invoiceData,
    // 更多数据
    moreInfoData: _storageData.moreInfoData,
    testData:[],
    authInfo:{
        title:'',
        tax_payer_identify_no:'',
        license_no:'',
        ep_reg_addr:'',
        ep_reg_contact:'',
        email:'',
        bank_name:'',
        bank_account_no:'',
        tax_payer_proof_pic_path:''
    },
    page:1,
    isEnd:false,
    isRead:false,
    // 行程单列表
    scheduleList:[],
     // 已选行程单
    selectedList:[],
    isLoad:false,
    money:0,
    cityList:[],
    
    selectAllFlag:false,

    scrollTop:0
    
  }
  
  // getters
  const getters = {}
  
  // actions
  const actions = {}
  
  // mutations
  const mutations = {

    initData(state, {user_id,ut}){
      let localStorageData = JSON.parse(localStorage.getItem('storageData')) 
      let isChangeUt =  sessionStorage.getItem('isChangeUt')
      let storageData;
      if(isChangeUt == '1') {
        storageData = localStorageData && localStorageData[user_id+ut]
      } else {
        storageData = localStorageData && (localStorageData[user_id+ut]||localStorageData[user_id])
      }
      if( storageData ){
        state.addressData = storageData.addressData || _storageData.addressData;
        state.invoiceData = storageData.invoiceData || _storageData.invoiceData;
        state.moreInfoData = storageData.moreInfoData || _storageData.moreInfoData;
      }
    },
    setRead(state, obj){
      state.isRead = obj
    },
    setLoad(state, obj){
      state.isLoad = obj
    },
    sethasTyOrder(state, obj){
      state.hasTyOrder = obj
    },
    setScheduleList(state, obj){
      state.scheduleList = obj
    },
    setCityList(state, list){
      let data = []
      for (const ee in list) {
        list[ee].map((e,i)=>{
          data.push(e)
        })
      }
      state.cityList = data
    },
    setSelectAll(state, flag){
      state.selectAllFlag = flag
    },
    
    removeSchedule(state,ids){
      let list = state.scheduleList;
      ids.map((ee)=>{
        list.map((e,i)=>{
            e.list.map((se,si)=>{
              if(ee.order_id == se.order_no) e.list.splice(si,1)
            })
            if(e.list.length==0)
              list.splice(i,1)
        })
      })
      if(list.length==1&& list[0].list.length==0 )
        state.scheduleList = [];
      else
        state.scheduleList = list;  
     
    },
    setSelectedList(state, obj){
      state.selectedList = obj
    },
    setPage(state, page){
      state.page = page
    },
    setListEnd(state, flag){
      state.isEnd = flag
    },
    setScrollTop(state, scrollTop){
      state.scrollTop = scrollTop
    },
    setMoreInfo(state, obj) {
      state.moreInfoData = Object.assign({},state.moreInfoData,obj)
    },
    setInvoiceData(state, obj) {
      state.invoiceData = Object.assign({},state.invoiceData,obj)
    },
    //
    setAddress(state, type) {
      state.addressData = type
    },
    setMoney(state, type) {
      state.money = type
    },
    setAuthInfo(state, obj) {
      state.authInfo = Object.assign({},state.authInfo,obj)
    },
    //重置地址
    resetAddress(state,type){
      state.addressData =   {
        addr_id:'',
        phone_no:'',
        receiver:'',
        address:'',
        province:'',
        city:'',
        county:'',
      }
    }
  }
  
  export default {
    state,
    getters,
    actions,
    mutations
  }
  
  
  


// WEBPACK FOOTER //
// ./src/store/modules/zero.js